import vi from './vi';
import en from './en';
import kr from './kr';

let langLocal = localStorage.getItem('sas_school_language');
let lang;

switch(langLocal) {
    case 'en':
        lang = en;
        break;
    case 'kr':
        lang = kr;
        break;
    case 'vi':
    default:
        lang = vi;
        break;
}

export default lang;

// Export individual language objects for dynamic usage
export { vi, en, kr };

// Helper function to get current language code
export const getCurrentLanguage = () => {
    return localStorage.getItem('sas_school_language') || 'vi';
};

// Helper function to get translation by key path (e.g., 'menu.dashboard')
export const t = (keyPath, defaultValue = '') => {
    const keys = keyPath.split('.');
    let result = lang;

    for (const key of keys) {
        if (result && typeof result === 'object' && key in result) {
            result = result[key];
        } else {
            return defaultValue || keyPath;
        }
    }

    return result || defaultValue || keyPath;
};
